import { render, staticRenderFns } from "./FigmaShapeLayer.vue?vue&type=template&id=36efec22"
import script from "./FigmaShapeLayer.vue?vue&type=script&lang=js"
export * from "./FigmaShapeLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports